// extracted by mini-css-extract-plugin
export default {"Container":"skeleton_Container__N0ams","wrapper":"skeleton_wrapper__iYVhN"};